import Delegate from "./Delegate";
import NP from './NP';


let _idCounter = 0;

export default class BaseObject {
	_Id: string;

	constructor(settings?: object)
	{
		this._initFields(settings);
		if (this._Id == null)
			this._Id = 'NP' + _idCounter++;
	}

	getId()
	{
		return this._Id;
	}


	_initFields(fields: object)
	{
		this._Id = null;
		if (fields)
		{
			for (let field in fields)
			{
				if (fields.hasOwnProperty(field))
				{
					let p = field,
						 value = (<any>fields)[field],
						 _p = "_" + p,
						 currentValue = (<any>this)[_p];
					if (currentValue === value)
						continue;
					let valueType = (typeof value).toLowerCase();
					if (value instanceof Delegate || valueType == "function")
					{
						if ((<any>this)[p] instanceof Delegate)
							(<any>this)[p].add(value);
						else if (currentValue === null)
							(<any>this)[_p] = value;
					}
					else
					{
						if (currentValue === undefined)
							continue;
						if (valueType === 'object')
						{
							if (currentValue && currentValue._initFields && !(value instanceof BaseObject))
								currentValue._initFields(value);
							else
								(<any>this)[_p] = value;
						}
						else
							(<any>this)[_p] = value;
					}
				}
			}
		}
	}

	_destroyArray(arr: Array<any>, checkAllItems: boolean = false)
	{
		if (!arr || arr.length === 0 || !checkAllItems && (!arr[0] || !arr[0].destroy))
			return;
		let i = arr.length;
		while (i--)
		{
			let arrItem = arr[i];
			if (arrItem)
			{
				let live = arrItem.isLive,
					 destroy = arrItem.destroy;
				if (destroy)
				{
					if (!live || live.call(arrItem))
						destroy.call(arrItem);
				}
			}
		}
	}

	_destroyObj(obj: object)
	{
		if (!obj) return;
		for (let member in obj)
		{
			if (obj.hasOwnProperty(member))
			{
				let m = (<any>obj)[member];
				if (m && m.destroy)
					m.destroy();
				(<any>obj)[member] = null;
			}
		}
	}



	destroy()
	{
		if (!this.isLive()) return;
		this._Id = null;
		(<any>this)._Parent = null;
		let isCtrl = this instanceof NP.Control;
		for (let member in this)
		{
			if (this.hasOwnProperty(member))
			{
				let valMember = (<any>this)[member];
				if (valMember)
				{
					if (Array.isArray(valMember))
						this._destroyArray(valMember);
					else if (valMember instanceof BaseObject)
						valMember.destroy();

					if (valMember.nodeType && valMember.events && isCtrl)
						(<any>this)._removeAllEvents(valMember);
				}
				delete this[member];
			}
		}
	}

	removeAllEvents(context: BaseObject)
	{
		if (context && this.isLive())
		{
			for (let propName in this)
			{
				if (this[propName] instanceof Delegate)
				{
					(<any>this)[propName].clear(context);
				}
			}
		}
	}

	isLive()
	{
		return this._Id != undefined;
	}

	// toTS()
	// {
	// 	let res = "";
	// 	for (let member in this)
	// 		if (this.hasOwnProperty(member))
	// 		{
	// 			if (this[member] instanceof Delegate)
	// 				res += `public ${member}: Delegate;\n`;
	// 			else if (this[member] instanceof Control)
	// 				res += `private ${member}: Control;\n`;
	// 			else
	// 				res += `private ${member}: ${typeof this[member]};\n`;
	// 		}
	// 	return res;
	// }
}